import { C } from "../dashboard/_shared";
import "./style.scss";

export default function MiniSparkline({ med, meta, tipo }) {
    if (!med || !med.length) return null;
    if (med.length === 1) {
        const v = med[0].v;
        return (
            <svg width={64} height={26} className="compMiniSparkline">
                <line x1={0} y1={13} x2={64} y2={13} stroke={C.border} strokeWidth={1} strokeDasharray="3 2" opacity={0.4} />
                <circle cx={32} cy={13} r={4} fill={C.g700} />
                <text x={38} y={17} fontSize={8} fill={C.text3}>{v}{tipo === "nps" ? "" : "%"}</text>
            </svg>
        );
    }
    const vals = med.map((m) => m.v);
    const w = 64,
        h = 26;
    const max = Math.max(...vals, meta) + 2;
    const min = Math.max(0, Math.min(...vals, meta) - 5);
    const x = (i) => Math.round((i / (vals.length - 1)) * w);
    const y = (v) => Math.round(h - ((v - min) / (max - min)) * h);
    const pts = vals.map((v, i) => `${x(i)},${y(v)}`).join(" ");
    const my = y(meta);
    const last = vals[vals.length - 1];
    const prev = vals[vals.length - 2];
    const up = last >= prev;
    return (
        <svg width={w} height={h} className="compMiniSparkline">
            <line
                x1={0}
                y1={my}
                x2={w}
                y2={my}
                stroke={C.p500}
                strokeWidth={1}
                strokeDasharray="3 2"
                opacity={0.5}
            />
            <polyline
                points={pts}
                fill="none"
                stroke={up ? C.green : C.red}
                strokeWidth={2}
                strokeLinejoin="round"
            />
            {vals.map((v, i) => (
                <circle
                    key={i}
                    cx={x(i)}
                    cy={y(v)}
                    r={i === vals.length - 1 ? 3 : 2}
                    fill={i === vals.length - 1 ? (up ? C.green : C.red) : C.border}
                />
            ))}
        </svg>
    );
}
